export function getFileName(value: unknown): string | undefined {
  return value instanceof File ? value.name : undefined;
}
